import React from 'react'

type Props = {}

const Home = (props: Props) => {
  return (
    <div>Home</div>
  )
}

export default Home